var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    staticClass: "myModal",
    attrs: {
      "width": "70",
      "mask-closable": false
    },
    model: {
      value: _vm.modal,
      callback: function ($$v) {
        _vm.modal = $$v;
      },
      expression: "modal"
    }
  }, [_c('div', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }), _c('Alert', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "type": "warning"
    }
  }, [_c('Icon', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "type": "ios-alert",
      "color": "#f90"
    }
  }), _c('span', {
    staticStyle: {
      "color": "#8a6d3b"
    }
  }, [_vm._v($t("q6ciljv", "若程序已安装，将自动呼起，若长时间没有打开，请检查是否已安装?"))])], 1), _vm.downLoadUrl ? _c('iframe', {
    ref: "iframe",
    staticClass: "iframe",
    attrs: {
      "frameborder": "0",
      "src": _vm.downLoadUrl
    }
  }) : _vm._e(), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('Checkbox', {
    on: {
      "on-change": _vm.change
    },
    model: {
      value: _vm.checked,
      callback: function ($$v) {
        _vm.checked = $$v;
      },
      expression: "checked"
    }
  }, [_vm._v($t("m5f4lo8", "已安装 不再提醒"))]), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.modal = false;
      }
    }
  }, [_vm._v($t("eod62", "关闭"))])], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };